import { Form, Button, Card } from 'react-bootstrap'
import AppLoader from 'components/general/AppLoader';
import { toast } from 'react-toastify'
import { useSelector } from "react-redux"
import { useState } from 'react'
import { EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html';

export default function AddNewModal({ getRoles }) {
  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL

  const [name, setName] = useState('')
  const [description, setDescription] = useState(EditorState.createEmpty())

  const [saveLoading, setSaveLoading] = useState(false)
  const [showCard, setShowCard] = useState(false)
  const handleCloseCard = () => setShowCard(false)
  const handleShowCard = () => setShowCard(true)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaveLoading(true)

    const descriptionHtml = draftToHtml(convertToRaw(description.getCurrentContent()))

    try {
      const response = await fetch(`${url}/meetingrole`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`
        },
        body: JSON.stringify({
          name,
          description: descriptionHtml
        })
      })

      if (response.status === 201) {
        await response.json()
        getRoles() // Refresh the role list
        handleCloseCard()
      } else {
        console.log(response)
        toast.error(`Failed to add Role: ${response.statusText}. Check the mandatory fields`, { position: 'bottom-left' })
      }
    } catch (error) {
      console.error(error)
      toast.error('Failed to add Role', { position: 'bottom-left' })
    } finally {
      setSaveLoading(false)
    }
  }

  return (
    <>
      {!showCard && (
        <Button
          variant="success"
          onClick={handleShowCard}
          className="mb-3 w-100 roles-admin-add-btn"
        >
          <i className="bi bi-plus"></i> Add New Role
        </Button>
      )}
      {showCard && (
        <Card className="mb-3 mt-3 roles-admin-form-card" id="addRole" style={{ display: showCard ? 'block' : 'none' }}>
          <Form>
            <Card.Body className='roles-admin-form-body'>
              <Form.Group className='mb-3'>
                <Form.Control
                  className='formInput'
                  placeholder='Role Name'
                  aria-label='Role Name'
                  name='role'
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Editor
                  editorState={description}
                  wrapperClassName="demo-wrapper"
                  toolbarClassName="toolbar-class"
                  editorClassName="editor-class"
                  onEditorStateChange={setDescription}
                  placeholder="Enter role description..."
                  toolbar={{
                    options: ['inline', 'blockType', 'list', 'textAlign', 'link'],
                    inline: {
                      options: ['bold', 'italic', 'underline']
                    },
                    blockType: {
                      inDropdown: false,
                      options: ['Normal', 'H4', 'H5', 'H6']
                    },
                    fontSize: {
                      visible: false,
                      options: [8, 9, 10, 11, 12, 14, 18]
                    },
                    list: {
                      inDropdown: false,
                      options: ['unordered', 'ordered']
                    },
                    textAlign: {
                      inDropdown: false
                    },
                    link: {
                      inDropdown: false
                    },
                    embedded: {
                      inDropdown: false
                    },
                  }}
                />
              </Form.Group>
            </Card.Body>
            <Card.Footer className='d-flex justify-content-between roles-admin-form-footer'>
              {saveLoading
                ?
                <>
                  <AppLoader />
                  Adding Role ...
                </>
                :
                <>
                  <Button variant="success" type='submit' onClick={handleSubmit} className='me-2 roles-admin-primary-btn'>
                    Add Role
                  </Button>
                  <Button variant="danger" onClick={handleCloseCard} className='roles-admin-danger-btn'>
                    Cancel
                  </Button>
                </>
              }
            </Card.Footer>
          </Form>
        </Card>
      )}
    </>
  )

}
